export class TransformationDataDTO {
  id: number | undefined;
  position: number[];
  rotation: number[];

  constructor(id: number | undefined, position: number[], rotation: number[]) {
    this.id = id;
    this.position = position;
    this.rotation = rotation;
  }
}
